exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TrialNoticeBar-166d57ef{padding:0 40px;background:#EBEED7;color:#212121}.TrialNoticeBar-166d57ef a.orange-f2f95328{color:#FA6400}\n", ""]);

// Exports
exports.locals = {
	"TrialNoticeBar": "TrialNoticeBar-166d57ef",
	"orange": "orange-f2f95328"
};